export enum allPredefinedFilters {
  inactiveUsers,
  withoutEmailAddress,
  withoutAlternativeID,
  administratedByMe,
  excludeInactiveCodes,
  hideHistoricalFactors,
  technicalUsers,
  excludeInactiveOwners,
  excludeUsedInDashboard,
  excludeUsedInCompanyReport,
  excludeSharedInReport,
  excludeInvalidOwners
}

export enum filterId {
  query = 'query',
  excludeUsersWithEmail = 'excludeUsersWithEmail',
  excludeInactiveUsers = 'excludeInactiveUsers',
  excludeTechnicalUsers = 'excludeTechnicalUsers',
  usersWithAlternativeId = 'usersWithAlternativeId',
  usersFromGroupsAdministratedByMe = 'usersFromGroupsAdministratedByMe',
  userType = 'userType',
  mainUserGroup = 'mainUserGroup',
  currentUserGroup = 'currentUserGroup',
  myUnit = 'myUnit',
  myLocation = 'myLocation',
  userRole = 'role',
  responsibleForUnit = 'responsibleForUnit',
  extendedAccess = 'extendedAccess',
  restrictedAccess = 'restrictedAccess',
  accessToScreen = 'accessToScreen',
  accessToOperation = 'accessOperation',
  accessToUserGroup = 'accessToUserGroup',
  userCode = 'userCode',
  roleCode = 'roleCode',
  disabledDate = 'disabledDate',
  type = 'type',
  includeInactiveCodes = 'includeInactiveCodes',
  hideHistoricalFactors = 'hideHistoricalFactors',
  caseType = 'application',
  userGroup = 'userGroup',
  fields = 'exclude',
  category = 'category',
  indicatorType = 'indicatorType',
  indicatorSubstanceUom = 'indicatorSubstanceUom',
  indicatorSubstanceCategory = 'indicatorSubstanceCategory',
  substanceCategory = 'substanceCategory',
  substanceUom = 'substanceUom',
  substance = 'substance',
  indicatorSubstance = 'indicatorSubstance',
  validFrom = 'validFrom',
  factor = 'factor',
  location = 'location',
  unit = 'unit',
  source = 'source',
  equipment = 'equipment',
  latestActivity = 'latestActivity',
  decimal = 'decimal',
  code = 'code',
  measurementSystem = 'measurementSystem',
  unitOfMeasureType = 'unitOfMeasureType',
  defaultValue = 'defaultValue',
  experienceTransferAlerts = 'experienceTransferAlerts',
  
  owner = 'owner',
  sharedWithUserGroup = 'sharedWithUserGroup',
  sharedWithUser = 'sharedWithUser',
  favouriteType = 'favouriteType',
  favouriteId = 'favouriteId',
  reportType = 'reportType',

  excludeInactiveOwners = 'excludeInactiveOwners',
  excludeUsedInDashboard = 'excludeUsedInDashboard',
  excludeUsedInCompanyReport = 'excludeUsedInCompanyReport',
  excludeSharedInReport = 'excludeSharedInReport',
  excludeInvalidOwners = 'excludeInvalidOwners',

  createdDate = 'createdDate',
  modifiedDate = 'modifiedDate'
}

export enum fieldType {
  root = 'root',
  application = 'application',
  excludeInherited = 'excludeInherited',
  date = 'date',
  number = 'number',
  codetable = 'codetable',
  defaultValues = 'defaultValues',
  domains = 'domains'
}

export const searchFiltersTranslations = {
  // filter options
  search: 7345,
  filters_title: 7556,
  clear_all_filters: 8139,

  // query filters
  search_on: 8143,

  // filter summary
  show_details: 7640,
  hide_details: 7641,
  filter_summary_exclude: 8034,
  filter_summary_exclude_sub: 8033,
  filter_summary_exclude_parent: 8179,

  // filter menus
  clear_filter: 7662,
  filter_menu_option_include: 7698,
  filter_menu_option_exclude: 7693,
  filter_menu_option_include_sub: 7696,
  filter_menu_option_exclude_sub: 7691,
  filter_menu_option_include_parent: 8180,
  filter_menu_option_exclude_parent: 8178,

  // predefined filters
  filters_predefined_filters: 7553,
  filters_exclude: 7638,
  filters_include: 7639,

  // filter date range
  filters_date_range_to: 7600,
  filters_date_range_from: 7567,
  filters_date_range_date_interval: 3707,
  filters_not_specified_title: 7832,
  filters_not_specified_subtitle: 7831,

  // filters decimal range
  filters_must_be_withing_range: 8679,
  filters_decimal_range: 8678,

  // filter validation
  number_validator_error: 7725,
  must_be_within_range: 7939,
  default_value_info_text: 9063
};

export type SearchFiltersTranslation = {
  readonly [T in keyof typeof searchFiltersTranslations]: string
};

export const defaultApplication: number = 4;
